import React from 'react';

const HealthDisclaimer = () => {
  return (
    <div className="health-disclaimer">
      <div className="health-disclaimer-inner">
        <p className="health-disclaimer-title">Disclaimer</p>
        <p className="health-disclaimer-text">
          I'm not a medical professional — I'm someone with a deep personal interest in health,
          nutrition, and long-term wellbeing, who reads widely and experiments with these ideas
          personally and within my family. Everything on this page is my personal synthesis of
          publicly available research and guidelines, cited where possible, and it is <em>not</em> medical
          advice. Always consult a qualified doctor, dietitian, or other medical professional before
          making health, nutrition, or fitness decisions — especially for children, during pregnancy,
          or if you have an existing medical condition.
        </p>
      </div>
    </div>
  );
};

export default HealthDisclaimer;
